import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { AnalyticsContext } from '@carvana/eventable-clickstream';

import MenuButton from '../../../Shared/MenuButton';
import MenuDrawerItem from '../../../Shared/MenuDrawerItem';
import MobileDropdownArrow from '../../../Shared/MobileDropdownArrow';

const StyledMenuDrawerItem = styled(MenuDrawerItem)`
  background-color: ${props => props.theme.carvana.gray.background};
  padding: 0 32px;
`;

const InnerDrawerItem = styled.div`
  flex: 1;
  height: ${props => (props.isExpanded ? '202px;' : '60px;')};
  overflow: hidden;
  transition: height 200ms ease-out;
`;

const StyledMenuButton = styled(MenuButton)`
  display: flex;
  flex: 1;
  height: 60px;

  &:hover {
    color: ${props => props.theme.carvana.blue.dark};
    text-decoration: none;
  }
`;

const DropdownWrapper = styled.div`
  margin: -15px 0 37px;
  display: ${props => (props.isExpanded ? 'block' : 'none')};
`;

const DropdownButton = styled(MenuButton)`
  color: ${props => props.theme.carvana.blue.primary};
  display: flex;
  flex: 1;
  font-size: 12px;
  font-weight: 700;
  justify-content: flex-start;
  padding: 16px 0 6px 21px;
  text-decoration: none;
  letter-spacing: 0;
`;

class AboutCarvana extends PureComponent {
  static contextType = AnalyticsContext;

  constructor() {
    super();
    this.state = {
      isExpanded: false,
    };

    this.handleExpansionToggle = this.handleExpansionToggle.bind(this);
  }

  handleExpansionToggle() {
    this.setState(prevState => ({
      isExpanded: !prevState.isExpanded,
    }));
  }

  handleClickLink = (ev, name) => {
    ev.preventDefault();
    const href = ev?.target?.href || '';
    this.context.trackEvent('user platform - header - clicked about carvana link', { platform: 'mobile', link: name });
    window.location.href = href;
  }

  render() {
    const { isExpanded } = this.state;
    return (
      <StyledMenuDrawerItem>
        <InnerDrawerItem isExpanded={isExpanded}>
          <StyledMenuButton
            onClick={this.handleExpansionToggle}
            disableHref
            eventName="user platform - header - expanded about carvana"
            eventData={{ platform: 'mobile' }}
          >
            About Carvana
            <MobileDropdownArrow isExpanded={isExpanded} />
          </StyledMenuButton>
          <DropdownWrapper isExpanded={isExpanded}>
            <DropdownButton onClick={e => this.handleClickLink(e, 'Our Story')} href="/about-us" target="_self">
              Our Story
            </DropdownButton>
            <DropdownButton onClick={e => this.handleClickLink(e, 'Careers')} href="/careers" target="_self">
              Careers
            </DropdownButton>
            <DropdownButton onClick={e => this.handleClickLink(e, 'Customer Reviews')} href="/reviews" target="_self">
            Customer Reviews
            </DropdownButton>
          </DropdownWrapper>
        </InnerDrawerItem>
      </StyledMenuDrawerItem>
    );
  }
}

export default AboutCarvana;
